import { render, staticRenderFns } from "./algorithm.vue?vue&type=template&id=27672ca1&scoped=true&"
import script from "./algorithm.vue?vue&type=script&lang=js&"
export * from "./algorithm.vue?vue&type=script&lang=js&"
import style0 from "./algorithm.vue?vue&type=style&index=0&id=27672ca1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27672ca1",
  null
  
)

export default component.exports